import { Routes, Route, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Tag from "./tags/Tag";
import Category from "./categories/Category";
import Merchant from "./merchants/Merchant";
import Account from "./accounts/Account";
import Transactions from "./transactions/Transactions";
import Investments from "./investment/Investments"
import {apiFetch} from "../api"
import Recurring from "../recurring/Recurring";
import {BASE_URL as u} from "../../commonUrls";

const BASE_URL = `${u}/account`;

export default function ExpenseTracker() {
  const [balance, setBalance] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  // TODO: replace with auth context later
  const userId = "u-c136202b-94f4-4e51-aa0b-72db0503c362";

  useEffect(() => {
    fetchBalance();
  }, []);

  const fetchBalance = async () => {
    try {
      const response = await apiFetch(
        `${BASE_URL}`
      );

      if (!response.ok) {
        const err = await response.json();
        setError(err.message || "Unauthorized");
        return;
      }

      const data = await response.json();
      setBalance(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <p style={{ textAlign: "center" }}>Loading balance...</p>;
  

  return (
    <Routes>

      {/* DEFAULT /expense */}
      <Route 
        index
        element={
          <div style={{ padding: "30px" }}>

            {/* BALANCE */}
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <div style={{ fontSize: "14px", color: "#777" }}>Total Balance</div>
            <div style={{ fontSize: "36px", fontWeight: "bold" }}>
              ₹ {balance ?? 0}
            </div>
          </div>

          {/* NON-BLOCKING ERROR MESSAGE */}
          {error && (
            <div style={{ textAlign: "center", color: "#d97706", marginBottom: "15px" }}>
              No account found yet. Create your first account to start tracking finances.
            </div>
          )}


            {/* BUTTONS */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                gap: "15px",
                maxWidth: "600px",
                margin: "0 auto",
              }}
            >
              <ActionButton label="Tags" onClick={() => navigate("tags")} />
              <ActionButton label="Categories" onClick={() => navigate("categories")} />
              <ActionButton label="Accounts" onClick={() => navigate("accounts")} />
              <ActionButton label="Merchants" onClick={() => navigate("merchants")} />
              <ActionButton label="Transactions" onClick={() => navigate("transactions")} />
              {/* <ActionButton label="FD" onClick={() => navigate("investments/fd")} />
              <ActionButton label="RD" onClick={() => navigate("investments/rd")} />
              <ActionButton label="Portfolio" onClick={() => navigate("investments/list")} /> */}
              <ActionButton label="Recurring" onClick={()=> navigate("recurring")} />
            </div>
          </div>
        }
      />
      {/* <Route index element={ DASHBOARD } /> */}

      {/* SUB ROUTES */}
      <Route path="tags/*" element={<Tag />} />
      <Route path="categories/*" element={<Category />} />
      <Route path="merchants/*" element={<Merchant />} />
      <Route path="accounts/*" element={<Account />} />
      <Route path="transactions/*" element={<Transactions />} />
      <Route path="investments/*" element={<Investments />} />
      <Route path="recurring/*" element={<Recurring/>} />
    </Routes>
  );
}

function ActionButton({ label, onClick }) {
  return (
    <button
      style={{
        padding: "15px",
        fontSize: "16px",
        borderRadius: "8px",
        border: "1px solid #ddd",
        cursor: "pointer",
        background: "#fafafa",
        fontWeight: "500",
      }}
      onClick={onClick}
    >
      {label}
    </button>
  );
}
